import { Component, Input } from '@angular/core';

@Component({
  selector: 'sgc-sub-header',
  templateUrl: './sub-header.component.html',
  styleUrls: ['./sub-header.component.scss'],
})
export class SubHeaderComponent {
  @Input() title!: string;
  @Input() description!: string;
}
